// src/components/auth/CpfBox.jsx
//
// RE-VESTIDO em 09/09 — Entrada.dc.html (tela `login`), § 1 do prompt.
//
// É a MESMA casca do login, porque é o mesmo gesto: um CPF e um "Avançar".
// A diferença é só o título e para onde o fluxo vai.
//
// SÓ O DESENHO MUDOU: `verificarCpfExistente` está intacta — mesma validação,
// mesma `checkCpfStatus`, mesmos desvios por status, mesmas mensagens.

import React, { useState } from "react";
import Style from "../../styles/components/auth/Entrada.module.scss";
import Loader from "../../design/components/Loader/Loader";
import { getFunctions, httpsCallable } from "firebase/functions";
import { validateCpfWithMessage, sanitizeCpf } from "../../utils/cpf";
import { callFirebaseFunction } from "../../utils/firebaseFunctionCaller";
import Politicas from '../../pages/politicas/PagePoliticas'
import Offcanvas from "../common/SwipeableOffcanvas.jsx";
import MarcaEntrada from "./MarcaEntrada.jsx";

const CpfBox = ({ formData, handleInputChange, handleNextStepCPF, handlePreviousStep, setActiveTab, setStep, setCpf, setMensagemSistema }) => {
  const [loading, setLoading] = useState(false);
  const [erroValidacao, setErroValidacao] = useState("");
  const functions = getFunctions(undefined, "southamerica-east1");
  const [showOffcanvas, setShowOffcanvasPoliticas] = useState(false);

  const verificarCpfExistente = async () => {
    const erro = validateCpfWithMessage(formData.CPF);
    if (erro) {
      setErroValidacao(erro);
      return;
    }

    setLoading(true);
    setErroValidacao("");
    setMensagemSistema("");

    try {
      const cpfLimpo = sanitizeCpf(formData.CPF);
      const data = await callFirebaseFunction("checkCpfStatus", { cpf: cpfLimpo });
      const { status } = data || {};

      if (status === 'exists' || status === 'excluded') {
        setCpf(formData.CPF);
        setMensagemSistema("CPF já cadastrado. Por favor, faça o login.");
        setActiveTab("login");
        setStep(1);
      } else {
        handleNextStepCPF();
      }
    } catch (err) {
      console.error("Erro ao verificar CPF existente:", err);
      setMensagemSistema("Erro ao verificar CPF. Tente novamente.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={Style.tela}>
      <span className={Style.fundoLogin} aria-hidden="true" />

      <MarcaEntrada />

      <div className={Style.folha}>
        <span className={Style.puxador} aria-hidden="true" />
        <h1 className={Style.titulo}>Criar conta</h1>

        <div className={Style.campo}>
          <label className={Style.rotulo} htmlFor="cadastro-cpf">CPF</label>
          <input
            id="cadastro-cpf"
            className={Style.entrada}
            type="tel"
            name="CPF"
            maxLength="14"
            value={formData.CPF}
            onChange={handleInputChange}
            onKeyDown={(e) => e.key === "Enter" && verificarCpfExistente()}
            placeholder="000.000.000-00"
            inputMode="numeric"
          />
          {erroValidacao && <p className={Style.erro}>{erroValidacao}</p>}
        </div>

        <button
          type="button"
          className={Style.primario}
          onClick={verificarCpfExistente}
          id="nextButton"
          disabled={loading}
        >
          {loading ? <Loader tamanho={28} /> : 'Avançar'}
        </button>

        <p className={Style.troca}>
          Já tem conta?
          <button
            type="button"
            className={Style.trocaLink}
            onClick={() => { setActiveTab("login"); setStep(1); }}
          >
            Fazer login
          </button>
        </p>
      </div>

      <Offcanvas show={showOffcanvas} onHide={() => setShowOffcanvasPoliticas(false)} placement="end">
        <Offcanvas.Body>
          <Politicas />
        </Offcanvas.Body>
      </Offcanvas>
    </div>
  );
};

export default CpfBox;
